const requireStates = (requireContext, initialStates) => {
  return requireContext
    .keys()
    .map(context => requireContext(context).states)
    .reduce((final, cur) => (cur ? final.concat(cur) : final), initialStates);
};

export default requireStates;



// WEBPACK FOOTER //
// ./src/util/require-states.js